import type { Category } from "./categories";

export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  categoryId: string;
  coverImage: string;
  publishDate: string;
  author: string;
  viewCount: number;
  tags: string[];
  isBreaking: boolean;
  isHot: boolean;
}

export const articles: Article[] = [
  {
    id: "art-1",
    title: "独家：某顶流男星深夜密会神秘女子，疑似新恋情曝光",
    summary: "近日有媒体拍到某当红男星深夜与一神秘女子一同返回住所，两人举止亲密，疑似新恋情浮出水面。据知情人士透露，两人已交往数月。",
    content: `<p>近日，有知名娱记拍到某当红男星在深夜时分与一名神秘女子一同出现在某高档小区门口。据目击者称，两人全程举止亲密，该男星还贴心地为女方披上外套，随后一同进入小区。</p><p>据知情人士透露，该女子并非圈内人，而是某知名企业的高管。两人在一次商业活动中相识，目前已低调交往近三个月。该男星的经纪公司暂未对此事作出回应。</p><p>值得关注的是，该男星此前曾在采访中表示"有好消息会第一时间与大家分享"，这让不少粉丝猜测是否好事将近。不过也有网友扒出该女子此前与另一位男艺人的绯闻，使得这段关系变得更加扑朔迷离。</p><p>这已经是本月第三位被拍到恋情绯闻的一线艺人了。娱乐圈的感情动态向来是吃瓜群众最关注的话题，这次又会掀起怎样的波澜？让我们拭目以待。</p>`,
    categoryId: "cat-1",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20scene%20at%20night%2C%20a%20famous%20male%20star%20walking%20with%20a%20woman%20in%20the%20dark%2C%20paparazzi%20style%20photography%2C%20warm%20street%20lights%2C%20cinematic%20mood%2C%20blurred%20background%20with%20city%20night%20atmosphere%2C%20editorial%20style%2C%20warm%20dark%20tones&width=800&height=450&seq=article-cover-01&orientation=landscape",
    publishDate: "2026-08-07",
    author: "吃瓜老司机",
    viewCount: 125600,
    tags: ["顶流男星", "恋情曝光", "深夜密会", "明星八卦"],
    isBreaking: true,
    isHot: true,
  },
  {
    id: "art-2",
    title: "某综艺节目录制现场爆发冲突，两位嘉宾当场翻脸",
    summary: "据现场工作人员爆料，某热门综艺节目最新一期录制过程中，两位常驻嘉宾因游戏环节产生矛盾，现场气氛一度剑拔弩张，节目组紧急叫停录制。",
    content: `<p>日前，某热门综艺节目在录制最新一期节目时发生意外状况。据现场工作人员爆料，两位常驻嘉宾在一个游戏环节中因规则争议发生激烈争执，双方各执一词互不相让，最终导致录制被迫中断。</p><p>爆料者称："当时现场气氛非常尴尬，两位嘉宾情绪都很激动，制片人不得不亲自出面调解。其他嘉宾也都面面相觑，不知道该怎么圆场。"</p><p>该综艺节目一直是收视率的保障，两位嘉宾此前也曾在节目中默契配合，这次的冲突让不少圈内人士感到意外。有分析认为，两人积怨已久，这次的游戏环节只是一个导火索。</p><p>截至目前，节目组和两位嘉宾的经纪团队均未就此事公开发表声明。但据内部消息，该期节目的播出时间可能会因此延后，节目组正在考虑是否需要重新录制相关环节。</p>`,
    categoryId: "cat-2",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20recording%20studio%20set%20with%20bright%20lights%2C%20two%20celebrities%20arguing%20dramatically%20on%20stage%2C%20tense%20atmosphere%2C%20production%20crew%20in%20background%2C%20cinematic%20lighting%2C%20warm%20studio%20tones&width=800&height=450&seq=article-cover-02&orientation=landscape",
    publishDate: "2026-08-06",
    author: "综艺前线记者",
    viewCount: 98300,
    tags: ["综艺节目", "嘉宾冲突", "录制事故", "内幕爆料"],
    isBreaking: false,
    isHot: true,
  },
  {
    id: "art-3",
    title: "天后级歌手被曝即将发布新专辑，制作阵容堪称豪华",
    summary: "多位音乐制作人在社交平台晒出与某天后级歌手的合影，引发粉丝热议。据业内人士透露，该歌手的新专辑已经完成录制，预计下月正式发布。",
    content: `<p>最近几天，多位国内顶级音乐制作人陆续在社交平台上晒出与同一位天后级歌手的录音棚合影，虽然都没有明确提及是在录制新歌，但这一连串的"巧合"已经让粉丝们炸开了锅。</p><p>据一位不愿透露姓名的音乐圈内部人士爆料，这位天后的新专辑已经秘密录制了将近半年时间，制作阵容堪称豪华——包括三位金曲奖最佳制作人、两位格莱美级别的混音师，以及多位国际知名的编曲人。</p><p>"这张专辑的风格跟她之前的作品有很大不同，加入了很多实验性的元素，"该消息人士表示，"但旋律性依然很强，有几首歌一听就是那种会火遍大街小巷的。"</p><p>粉丝们纷纷在评论区留言表示"等太久了，终于有新歌可以听了"。该歌手上一张专辑已经是三年前，期间虽然偶尔发布单曲，但完整专辑迟迟没有消息。如果爆料属实，这将是今年华语乐坛最受期待的专辑之一。</p>`,
    categoryId: "cat-3",
    coverImage: "https://readdy.ai/api/search-image?query=professional%20music%20recording%20studio%20interior%2C%20warm%20ambient%20lighting%2C%20microphone%20and%20mixing%20console%20in%20focus%2C%20luxury%20studio%20atmosphere%2C%20golden%20and%20dark%20tones%2C%20cinematic%20depth%20of%20field&width=800&height=450&seq=article-cover-03&orientation=landscape",
    publishDate: "2026-08-05",
    author: "乐坛观察员",
    viewCount: 78100,
    tags: ["天后歌手", "新专辑", "豪华制作", "音乐圈动态"],
    isBreaking: false,
    isHot: true,
  },
  {
    id: "art-4",
    title: "千万粉丝网红直播翻车，口误说出惊人内幕",
    summary: '某拥有千万粉丝的头部网红在直播带货时意外口误，疑似说出了与平台之间的秘密协议，瞬间引发弹幕刷屏。虽然事后紧急澄清，但争议仍在发酵。',
    content: `<p>昨晚，某拥有超过两千万粉丝的头部网红在进行日常直播带货时发生了一个意外——在介绍一款产品的时候，她不小心说出了"平台给我们保底"这句话，虽然立刻改口，但已经被直播间的观众截图录屏。</p><p>这句话迅速在各大社交平台引发热议。不少网友认为，这证实了头部主播和平台之间存在"保底协议"，即无论实际销售额如何，平台都会保证主播拿到一定的收入。这种做法虽然并非完全秘密，但从未有主播公开承认过。</p><p>事后该网红火速发布了一段澄清视频，解释说自己当时"嘴瓢了"，本意是说"平台给我们报底价"，并强调自己所有的直播数据都是真实的。但这段澄清显然没能平息争议。</p><p>业内人士分析，这次"直播翻车"事件可能会对整个直播带货行业产生连锁反应，监管部门此前已经多次强调要规范直播带货行业，这次事件或将成为新一轮整顿的导火索。</p>`,
    categoryId: "cat-4",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20female%20influencer%20live%20streaming%20with%20ring%20light%20setup%2C%20surprised%20expression%2C%20smartphone%20on%20tripod%2C%20warm%20room%20lighting%2C%20modern%20apartment%20interior%2C%20social%20media%20lifestyle%2C%20cinematic%20mood&width=800&height=450&seq=article-cover-04&orientation=landscape",
    publishDate: "2026-08-04",
    author: "直播圈探秘",
    viewCount: 156200,
    tags: ["网红翻车", "直播带货", "平台内幕", "口误爆料"],
    isBreaking: false,
    isHot: true,
  },
  {
    id: "art-5",
    title: "好莱坞巨星被曝即将来华拍戏，将与中国影帝合作",
    summary: "据可靠消息，某奥斯卡获奖演员已经签下合约，将在下半年赴中国拍摄一部中美合拍大片，与其搭档的是国内公认的演技派影帝。",
    content: `<p>国际影坛传来重磅消息！据好莱坞权威媒体报道，某奥斯卡获奖演员已经正式签下一部中美合拍大片的合约，将于今年下半年飞赴中国进行为期三个月的拍摄。</p><p>更令人兴奋的是，与这位好莱坞巨星搭档的不是别人，正是国内公认的演技派影帝——两人将在片中饰演一对亦敌亦友的跨国搭档。影片讲述了一个横跨中美两国的犯罪悬疑故事，据悉剧本经过了长达两年的打磨。</p><p>这部电影的投资规模预计将超过两亿美元，由好莱坞知名导演执导，中方团队则由国内最顶尖的制作公司负责。业内人士认为，这将是继几年前的合拍热潮之后，最值得期待的一部中美合拍项目。</p><p>目前该片暂未公布正式片名和具体上映日期，但消息一出已经在全球影迷中引起了巨大反响。不少中国影迷表示"终于能看到这两位实力派演员同台飙戏了"。</p>`,
    categoryId: "cat-5",
    coverImage: "https://readdy.ai/api/search-image?query=Hollywood%20movie%20set%20in%20Shanghai%20cityscape%20background%2C%20film%20camera%20equipment%2C%20international%20film%20production%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20atmosphere%2C%20professional%20film%20crew%20silhouettes&width=800&height=450&seq=article-cover-05&orientation=landscape",
    publishDate: "2026-08-03",
    author: "国际影讯",
    viewCount: 89200,
    tags: ["好莱坞", "合拍大片", "影帝合作", "国际娱乐"],
    isBreaking: false,
    isHot: false,
  },
  {
    id: "art-6",
    title: "知名女星被拍到带娃现身游乐场，疑似隐婚生子",
    summary: "某知名女演员近日被网友偶遇，带着一名约三岁的男童在某主题乐园游玩。照片中她全程牵着孩子的手，画面温馨。网友猜测这是她的孩子。",
    content: `<p>上周末，有网友在某知名主题乐园偶遇了一位当红女演员，并拍下了她带着一名小男孩游玩的照片。照片中，该女星穿着休闲，全程紧紧牵着大约三岁男童的手，两人有说有笑，画面十分温馨。</p><p>照片一经曝光立刻引发网友热议。有意思的是，这位女演员此前从未公开过自己的婚恋状况，更不用说有孩子了。一时间，"隐婚生子"的猜测铺天盖地。</p><p>不过也有粉丝出来澄清，称照片中的小男孩是该女星的侄子，她经常在假期带侄子出去玩。但这一说法并未能完全打消网友的疑虑，因为从照片来看两人的互动实在太过亲密自然。</p><p>截至目前，该女星及其团队保持沉默，没有对照片事件作出任何回应。吃瓜群众纷纷表示：不管是侄子还是儿子，先吃了这口瓜再说！</p>`,
    categoryId: "cat-1",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20amusement%20park%20on%20sunny%20day%2C%20ferris%20wheel%20and%20colorful%20rides%20in%20background%2C%20warm%20sunlight%2C%20family%20friendly%20atmosphere%2C%20bright%20and%20cheerful%20mood%2C%20candid%20photography%20style&width=800&height=450&seq=article-cover-06&orientation=landscape",
    publishDate: "2026-08-02",
    author: "明星家庭观察",
    viewCount: 108400,
    tags: ["隐婚生子", "女星带娃", "游乐场偶遇", "明星八卦"],
    isBreaking: false,
    isHot: true,
  },
  {
    id: "art-7",
    title: "收视冠军剧集被曝剧本抄袭，编剧圈炸锅了",
    summary: '今年收视率最高的电视剧近日陷入抄袭争议。多名编剧实名指出该剧多个情节与已有作品高度相似，制片方回应称“纯属巧合”。',
    content: `<p>今年毫无疑问的收视冠军电视剧，最近却陷入了巨大的争议之中。多名编剧圈人士在社交平台上实名发帖，指出该剧的核心情节和人物设定与多部已有的作品存在高度相似之处。</p><p>一位资深编剧晒出了详细的对比图表，列出了至少七处"惊人相似"的情节设计，并直言："这不可能是巧合，连台词的结构和节奏都几乎一模一样。"这条帖子迅速获得了大量转发和支持。</p><p>面对质疑，该剧的制片方发表了简短声明，表示"所有创作均为原创，如有雷同纯属巧合"，并强调剧本经过了法务部门的审核。但这个回应显然没能让质疑者满意。</p><p>编剧圈对此反应强烈，多位知名编剧联合发声，呼吁行业建立更完善的原创保护机制。这起事件也再次引发了公众对于影视创作中"借鉴"与"抄袭"界限的讨论。</p>`,
    categoryId: "cat-2",
    coverImage: "https://readdy.ai/api/search-image?query=dramatic%20TV%20drama%20scene%20with%20two%20actors%20facing%20each%20other%2C%20intense%20emotional%20moment%2C%20warm%20cinematic%20lighting%2C%20film%20set%20atmosphere%2C%20professional%20production%20quality%2C%20dark%20dramatic%20mood&width=800&height=450&seq=article-cover-07&orientation=landscape",
    publishDate: "2026-08-01",
    author: "剧本侦探",
    viewCount: 134700,
    tags: ["剧本抄袭", "收视冠军", "编剧争议", "影视圈内幕"],
    isBreaking: false,
    isHot: false,
  },
  {
    id: "art-8",
    title: "两位顶流歌手被曝在后台大打出手，起因竟是一句歌词",
    summary: "某音乐颁奖典礼后台发生惊人一幕。据目击者称，两位当红歌手因争抢压轴表演顺序发生口角，最终演变成肢体冲突，多位工作人员上前拉架。",
    content: `<p>上周末某大型音乐颁奖典礼的后台，发生了一起令人瞠目结舌的冲突事件。据多位目击者证实，两位当红歌手因为演出顺序的问题爆发了激烈争吵，随后甚至演变成了推搡。</p><p>据知情者还原，事情的起因是其中一位歌手在彩排时临时要求调整自己的表演顺序，想从中间位置换到压轴。但另一位歌手得知后坚决不同意，认为"压轴位置已经确定了不能改"。两人在后台狭路相逢时，据说其中一人先阴阳怪气地说了句"唱那么多年也就那几句"，对方立刻火冒三丈，冲突就此爆发。</p><p>现场多名工作人员和保镖费了好大劲才将两人分开。幸运的是，两人都没有受伤，颁奖典礼也按原计划顺利进行。但据说两人在当晚的表演中全程零互动，连最基本的礼貌性微笑都没有。</p><p>此事在音乐圈引起了不小的震动，毕竟这两位歌手平时在公众面前的形象都是温文尔雅的类型。有乐评人感叹："台前三分钟，台后十年功——不对，是十年仇。"</p>`,
    categoryId: "cat-3",
    coverImage: "https://readdy.ai/api/search-image?query=music%20awards%20show%20backstage%20area%2C%20dramatic%20lighting%2C%20two%20performers%20in%20conflict%2C%20stage%20crew%20intervening%2C%20tense%20atmosphere%2C%20warm%20backstage%20lighting%2C%20cinematic%20documentary%20style&width=800&height=450&seq=article-cover-08&orientation=landscape",
    publishDate: "2026-07-31",
    author: "乐坛密探",
    viewCount: 187300,
    tags: ["歌手冲突", "后台打架", "颁奖典礼", "乐坛内幕"],
    isBreaking: true,
    isHot: true,
  },
  {
    id: "art-9",
    title: "百万粉博主被封号后首次露面，状态憔悴引关注",
    summary: "上个月因违规被平台封禁的知名美妆博主近日被拍到在街头独自用餐，面容憔悴与往日光彩照人的形象判若两人，粉丝纷纷表示心疼。",
    content: `<p>上个月因涉嫌发布违规内容被平台永久封禁的知名美妆博主，在沉寂了近一个月后，近日被网友拍到独自一人在街边小店用餐。照片中的她素颜出镜，面容憔悴，头发随意扎起，与往日在镜头前精致妆容、自信满满的形象形成了巨大反差。</p><p>该博主在被封号之前拥有超过五百万粉丝，是美妆赛道公认的头部创作者之一。她的账号被封引起了广泛讨论，支持者认为平台的处罚过于严厉，反对者则指出她长期以来存在不少争议行为。</p><p>照片曝光后，大量粉丝涌入相关评论区表达关心，有人写道"不管怎样希望她能好好的"，也有人表示"做错事就要承担后果，但人都有改过的机会"。</p><p>据接近该博主的人士透露，她目前正在与平台积极沟通，希望尽快恢复账号，同时也考虑在其他平台开设新的账号重新开始。</p>`,
    categoryId: "cat-4",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20woman%20sitting%20alone%20at%20a%20small%20street%20side%20restaurant%2C%20natural%20candid%20photography%2C%20warm%20evening%20lighting%2C%20quiet%20melancholy%20mood%2C%20urban%20street%20scene%2C%20soft%20focus%20background&width=800&height=450&seq=article-cover-09&orientation=landscape",
    publishDate: "2026-07-30",
    author: "网红观察室",
    viewCount: 92100,
    tags: ["博主封号", "美妆网红", "近况曝光", "账号解封"],
    isBreaking: false,
    isHot: false,
  },
  {
    id: "art-10",
    title: "韩国顶流男团被曝内部不和，两名成员取关对方",
    summary: "韩娱圈再起波澜！某顶级男团的两名核心成员突然在社交平台互相取关，引发粉丝大规模猜测。有传闻称两人因个人资源分配问题产生严重分歧。",
    content: `<p>韩娱圈再次掀起波澜！眼尖的粉丝发现，某全球知名顶级男团的两名核心成员在Instagram上互相取消了关注，这一举动立刻在饭圈引发了轩然大波。</p><p>虽然两人都没有删除任何过往的合影或互动内容，但粉丝们从最近几次团体活动中已经察觉到了端倪——两人在舞台上虽然站位相邻，但全程几乎没有眼神交流，和以往亲密互动的状态完全不同。</p><p>据韩媒报道，两人的矛盾可能源于公司对其个人发展方向的规划存在分歧。其中一人希望更多地发展演员事业，而另一人则希望专注于音乐创作。在有限的资源面前，分歧逐渐加深。</p><p>该男团的经纪公司一如既往地保持了沉默，仅表示"艺人之间的SNS关注关系属于个人行为，公司不便干涉"。这个回应反而让粉丝们更加确信确实发生了什么事情。韩网的评论几乎一边倒地表示"又是一个名存实亡的团体"。</p>`,
    categoryId: "cat-5",
    coverImage: "https://readdy.ai/api/search-image?query=Kpop%20boy%20group%20performing%20on%20stage%20with%20dramatic%20lighting%2C%20tension%20between%20two%20members%2C%20concert%20atmosphere%2C%20fan%20light%20sticks%20in%20audience%2C%20colorful%20stage%20effects%2C%20warm%20and%20cool%20contrasting%20lights&width=800&height=450&seq=article-cover-10&orientation=landscape",
    publishDate: "2026-07-29",
    author: "韩流前线",
    viewCount: 201400,
    tags: ["韩国男团", "成员不和", "取关风波", "韩娱动态"],
    isBreaking: false,
    isHot: true,
  },
  {
    id: "art-11",
    title: "某知名导演被曝片场脾气暴躁，多次对演员爆粗口",
    summary: "多位曾在某知名导演剧组工作过的演员匿名爆料，称该导演在片场脾气极为暴躁，经常因为小事对演员和其他工作人员大发雷霆，甚至有摔东西的行为。",
    content: `<p>近日，多位曾在某知名导演剧组工作过的演员和工作人员选择匿名发声，揭露了这位在公众面前一向温和大度的导演在片场的另一面。</p><p>据一位演员回忆："有一场戏我NG了大概四五次，导演就直接把剧本摔在地上，当着全组一百多号人的面骂我'会不会演戏'。那种屈辱感我到现在都记得。"另一位工作人员则补充说："他心情不好的时候，全组都得绕着他走，连制片人都要看他的脸色。"</p><p>但也有人为这位导演辩护，认为他的"暴脾气"是出于对作品质量的高要求。"他的电影每一部都是精品，这种精益求精的态度虽然让一起工作的人很痛苦，但最终呈现出来的效果确实没得说。"</p><p>这起爆料在影视圈引发了关于"创作态度"和"职场尊重"之间平衡的讨论。有网友表示："追求艺术不能成为不尊重人的借口。"也有人认为："天才总是有怪癖的，只要作品好就行。"目前该导演本人尚未对此事作出回应。</p>`,
    categoryId: "cat-2",
    coverImage: "https://readdy.ai/api/search-image?query=film%20director%20on%20movie%20set%20yelling%20angrily%2C%20dramatic%20lighting%2C%20film%20crew%20members%20looking%20nervous%20in%20background%2C%20professional%20camera%20equipment%2C%20tense%20working%20environment%2C%20cinematic%20mood&width=800&height=450&seq=article-cover-11&orientation=landscape",
    publishDate: "2026-07-28",
    author: "片场观察员",
    viewCount: 115800,
    tags: ["导演脾气", "片场暴力", "演员爆料", "影视圈黑幕"],
    isBreaking: false,
    isHot: false,
  },
  {
    id: "art-12",
    title: "某女星社交平台小号被扒，内容与公开形象大相径庭",
    summary: "网友通过蛛丝马迹挖出了某清纯人设女星的小号，小号中的言论风格与她的公开形象完全不同，毒舌吐槽同行、抱怨工作安排，引发人设崩塌危机。",
    content: `<p>吃瓜群众又有大发现！近日有细心的网友通过分析发布时间、定位信息和用词习惯，成功扒出了某以"清纯玉女"形象著称的女明星的社交平台小号。小号中的内容与她的公开形象形成了惊人对比。</p><p>在这个小号中，该女星完全放飞自我：吐槽合作过的某男演员"演技差还爱摆谱"，抱怨经纪公司给她安排的工作"累死累活还不赚钱"，甚至对粉丝送的礼物评头论足说"送的什么破玩意儿"。这些言论与她在公开场合温婉可人的形象判若两人。</p><p>虽然该小号在被曝光后迅速被清空并注销，但截图已经在网络上广泛传播。网友的反应两极分化：有人批评她"人设崩塌"、"当面一套背后一套"，也有人表示理解："明星也是人，谁还没有个发泄的地方？总比当面装模作样好。"</p><p>截至目前，该女星及其团队均未就小号事件作出回应。业内人士分析，这类事件对商业价值的冲击可能比一般的绯闻更加严重，因为品牌方非常看重代言人的公众形象一致性。</p>`,
    categoryId: "cat-1",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20actress%20holding%20smartphone%20looking%20at%20camera%20with%20mixed%20expression%2C%20split%20lighting%20effect%20half%20bright%20half%20dark%2C%20celebrity%20portrait%20style%2C%20warm%20soft%20lighting%2C%20editorial%20fashion%20photography&width=800&height=450&seq=article-cover-12&orientation=landscape",
    publishDate: "2026-07-27",
    author: "吃瓜第一线",
    viewCount: 168900,
    tags: ["小号被扒", "人设崩塌", "女星吐槽", "社交平台"],
    isBreaking: false,
    isHot: true,
  },
];

export const getArticleById = (id: string): Article | undefined =>
  articles.find((a) => a.id === id);

export const getArticlesByCategory = (categoryId: string): Article[] =>
  articles.filter((a) => a.categoryId === categoryId);

export const getBreakingArticles = (): Article[] =>
  articles.filter((a) => a.isBreaking);

export const getHotArticles = (): Article[] =>
  articles.filter((a) => a.isHot).sort((a, b) => b.viewCount - a.viewCount);

export const getRelatedArticles = (article: Article, limit: number = 3): Article[] =>
  articles
    .filter((a) => a.id !== article.id && a.categoryId === article.categoryId)
    .sort((a, b) => b.viewCount - a.viewCount)
    .slice(0, limit);

export const getLatestArticles = (limit: number = 10): Article[] =>
  [...articles].sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  ).slice(0, limit);